var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomerService(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80,
    height: 74,
    viewBox: "0 0 80 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3384",
    "data-name": "Rectangle 3384",
    width: 56.755,
    height: 49.58,
    fill: "#5e84c3"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14378",
    "data-name": "Group 14378",
    transform: "translate(-869 -1119)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_160",
    "data-name": "Ellipse 160",
    cx: 34,
    cy: 34,
    r: 34,
    transform: "translate(869 1119)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_14377",
    "data-name": "Group 14377",
    transform: "translate(540 21)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14376",
    "data-name": "Group 14376",
    transform: "translate(349 1115)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14375",
    "data-name": "Group 14375",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42158",
    "data-name": "Path 42158",
    d: "M297.863,175.884a8.607,8.607,0,0,1-.579,1.242,3.274,3.274,0,0,1-2.812,1.5c-2.031.025-4.063,0-6.1.022-.48,0-.616-.15-.611-.638.027-2.77.047-5.541.01-8.311-.062-4.588-1.33-8.728-4.655-12.066a.945.945,0,0,1-.1-.16,6.148,6.148,0,0,1,3.8-1.613,25.231,25.231,0,0,1,4.965.1A7.256,7.256,0,0,1,297.759,162a1.211,1.211,0,0,0,.1.247Z",
    transform: "translate(-241.108 -132.717)",
    fill: "#5e84c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42159",
    "data-name": "Path 42159",
    d: "M104.376,181.714c-3.435,0-6.87.012-10.305-.005a3.793,3.793,0,0,1-3.619-2.2,3.542,3.542,0,0,1-.382-1.425c-.07-2.529-.123-5.059-.11-7.588a17.8,17.8,0,0,1,1.155-7.051,13.062,13.062,0,0,1,9.7-7.855,25.949,25.949,0,0,1,6.726-.262,11.8,11.8,0,0,1,6.981,2.584,13.327,13.327,0,0,1,5.453,10.923c.009,2.881.018,5.762,0,8.643-.018,2.721-1.285,4.051-4.024,4.13-3.856.112-7.713.151-11.57.221,0-.037,0-.075,0-.112",
    transform: "translate(-76.636 -132.246)",
    fill: "#5e84c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42160",
    "data-name": "Path 42160",
    d: "M136.129,0a9.657,9.657,0,1,1-9.616,9.784A9.635,9.635,0,0,1,136.129,0",
    transform: "translate(-107.777 0)",
    fill: "#5e84c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42161",
    "data-name": "Path 42161",
    d: "M14.88,157.15a15.641,15.641,0,0,0-4.1,7.039,25.426,25.426,0,0,0-.732,6.578c0,2.363.023,4.726.035,7.089,0,.108,0,.216,0,.378-.238.023-.453.061-.667.061-2.012,0-4.025.014-6.037-.006A3.265,3.265,0,0,1,0,174.845q0-5.954,0-11.908a7.437,7.437,0,0,1,6.929-7.468,17.055,17.055,0,0,1,5.177.233,6.605,6.605,0,0,1,2.772,1.448",
    transform: "translate(0 -132.371)",
    fill: "#5e84c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42162",
    "data-name": "Path 42162",
    d: "M24.83,47.917a6.108,6.108,0,1,1-6.105,6.021,6.08,6.08,0,0,1,6.105-6.021",
    transform: "translate(-15.952 -40.821)",
    fill: "#5e84c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42163",
    "data-name": "Path 42163",
    d: "M288.3,47.917a6.108,6.108,0,1,1-6.09,6.092,6.083,6.083,0,0,1,6.09-6.092",
    transform: "translate(-240.416 -40.821)",
    fill: "#5e84c3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_3385",
    "data-name": "Rectangle 3385",
    transform: "translate(345 1108)",
    fill: "#5e84c3",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 63,
    height: 63,
    fill: "none"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerService);
export default __webpack_public_path__ + "static/media/customer-service.4f7d3bb933ab15e53f7cf2d771623bfa.svg";
export { ForwardRef as ReactComponent };